import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";

import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    color: ComponentProps<typeof Button>["color"];
    className?: string;
};

export const ShowAllButton = ({ color, className }: Props) => {
    const { t } = useGranite();
    const { autocompleteState, autocompleteActions } = useSearchBarContext();

    const amountOfProducts = autocompleteState?.context.nbProductHits;

    if (!amountOfProducts || autocompleteState?.query?.length === 0) {
        return null;
    }

    const handleShowAllProductsClick = () => {
        if (!autocompleteState?.query) return;

        autocompleteActions?.submit(autocompleteState?.query);
    };

    return (
        <Button
            type={"button"}
            color={color}
            className={cn("", className)}
            onClick={handleShowAllProductsClick}
        >
            {t("searchBox.panel.products.header.showAll", amountOfProducts)}
        </Button>
    );
};
